/* app/js/src/components/broadcast/broadcast-editor/broadcast-editor.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host,
.container {
  width: 99.3%;
  height: 100%;
  overflow: hidden;
  padding-left: 0.7%;
  background-color: #ebf0f4;
}
.header {
  min-height: 3.563rem;
  position: relative;
}
.header .preset-name {
  position: absolute;
  left: 0;
}
.header .preset-name h3 {
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header .preset-name h3:focus-visible {
  outline: initial;
  border-bottom: 2px solid #d0d0d0;
}
.header .status {
  position: absolute;
  left: calc(50% - 10.5rem);
  transform: translateX(-50%);
  text-align: center;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
  -webkit-user-select: none;
  user-select: none;
  font-size: 1.2rem;
  color: white;
  padding: 5px 10px;
}
.header .status.live {
  background-color: #ef5d5d;
}
.header .status.edit {
  background-color: #55928e;
}
.previews {
  flex: 0 0 40%;
  display: grid;
  grid-template-columns: 1fr 1fr 0.2fr;
  gap: 12px;
}
.previews.mam-collapsed {
  flex: 0 0 35%;
}
.previews .label {
  color: white;
  font-weight: bold;
  -webkit-user-select: none;
  user-select: none;
}
.previews .video {
  width: 100%;
  height: 100%;
  background-image: url(/assets/stream-preview-loader.gif);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.previews .preview-video .preview-header {
  background-color: #55928e;
  padding: 0.5vw;
}
.previews .program-video {
  position: relative;
}
.previews .program-video .preview-header {
  background-color: #ef5d5d;
  padding: 0.5vw;
  position: relative;
}
.previews .preview-side-panel {
  width: 15vw;
  position: relative;
}
.preview-actions {
  flex-grow: 0.1;
  font-size: 1.7vh;
  position: relative;
  height: 4vh;
}
.preview-actions .button {
  font-weight: bold;
  border-radius: 6px;
  padding: 6px;
}
.preview-actions .button:hover {
  background-color: #dce5eb;
}
.preview-actions .broadcast-buttons {
  position: absolute;
  left: calc(50% - 10.5rem);
  transform: translateX(-50%);
  height: 100%;
  min-height: 3vh;
}
.preview-actions .broadcast-buttons .cut-button {
  color: #524e59;
}
.preview-actions .scheduler-buttons {
  min-height: 4vh;
  position: absolute;
  right: 0;
  width: 23rem;
}
.preview-actions .scheduler-buttons .start-live-button {
  color: red;
}
.preview-actions .scheduler-buttons .panel {
  position: absolute;
}
.preview-actions .scheduler-buttons .scheduler-button svg:hover path {
  fill: black;
}
.preview-actions .divider {
  width: 0.1vw;
  background-color: #dce5eb;
  height: 80%;
  margin-right: 0.1vw;
}
.switch-panels {
  flex-grow: 80;
  min-height: 0;
}
.switch-panels .switcher-header {
  background-color: #dce5eb;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: stretch;
  flex-wrap: nowrap;
  gap: 2px;
  overflow-x: auto;
  overflow-y: hidden;
  border-bottom: 1px solid #cfd7de;
}
.switch-panels .switcher-header .switcher-button {
  background-color: #d8dce2;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  min-height: 36px;
  flex: 0 1 12vw;
  flex-basis: 12vw;
  min-width: 8rem;
  max-width: 14rem;
  width: auto;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: 0.04em;
  border: 1px solid #cfd7de;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  transition:
    background-color 0.12s ease,
    color 0.12s ease,
    box-shadow 0.12s ease;
}
.switch-panels .switcher-header .switcher-button:hover:not(.selected) {
  background-color: #e2e6eb;
}
.switch-panels .switcher-header .switcher-button.selected {
  flex: 0 0 auto;
  flex-basis: auto;
  width: fit-content;
  min-width: min-content;
  max-width: none;
  background-color: #fbfcfd;
  border-color: #cfd7de;
  box-shadow: 0 1px 0 0 #fbfcfd;
  margin-bottom: -1px;
  z-index: 1;
}
.switch-panels .switcher-header .switcher-button.selected .switcher-name,
.switch-panels .switcher-header .switcher-button.selected .switcher-index {
  color: #87cef6;
  font-weight: 700;
}
.switch-panels .switcher-header .switcher-button.selected .switcher-name {
  display: inline-block;
  flex: 0 0 auto;
  width: auto;
  min-width: min-content;
  max-width: none;
  overflow: visible;
  field-sizing: content;
}
.switch-panels .switcher-header .switcher-button .divider {
  background-color: #cfd7de;
  width: 1px;
  height: 18px;
  flex-shrink: 0;
  margin: 0;
}
.switch-panels .switcher-header .switcher-button .switcher-index {
  flex-shrink: 0;
  min-width: 1ch;
  color: #8d8f93;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.06em;
  text-align: center;
}
.switch-panels .switcher-header .switcher-button .switcher-name {
  flex: 1;
  min-width: 0;
  color: #8d8f93;
  font-weight: 600;
  letter-spacing: 0.05em;
  white-space: nowrap;
  overflow: hidden;
  border-bottom: 2px solid transparent;
}
.switch-panels .switcher-header .switcher-button .switcher-name.text-overflow-ellipsis {
  text-overflow: ellipsis;
}
.switch-panels .switcher-header .switcher-button .switcher-name:focus-visible {
  outline: none;
  border-bottom-color: #d0d0d0;
}
.switch-panels .switcher-header .switcher-button .switcher-x-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-left: 2px;
  color: #8d8f93;
  border-radius: 3px;
  transition: color 0.12s ease, background-color 0.12s ease;
}
.switch-panels .switcher-header .switcher-button .switcher-x-button:hover:not(.disabled) {
  color: #524e59;
  background-color: rgba(35, 47, 58, 0.08);
}
.switch-panels .switcher-header .resize-mode-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  align-self: center;
  padding: 6px 10px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  white-space: nowrap;
  transition:
    color 0.12s ease,
    background-color 0.12s ease,
    border-color 0.12s ease;
}
.switch-panels .switcher-header .resize-mode-toggle span {
  -webkit-user-select: none;
  user-select: none;
}
.switch-panels .switcher-header .resize-mode-toggle:hover {
  color: rgba(0, 0, 0, 0.75);
  background-color: rgba(0, 0, 0, 0.06);
  border-color: rgba(0, 0, 0, 0.08);
}
.switch-panels .switcher-header .resize-mode-toggle.active {
  color: #55928e;
  background-color: rgba(85, 146, 142, 0.12);
  border-color: rgba(85, 146, 142, 0.35);
}
.switch-panels .switcher-header .switcher-add-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  align-self: center;
  width: 36px;
  height: 36px;
  margin: 0 0 0 4px;
  color: rgba(35, 47, 58, 0.65);
  background: rgba(35, 47, 58, 0.08);
  border: 1px solid rgba(35, 47, 58, 0.12);
  border-radius: 4px;
  transition: background-color 0.12s ease, border-color 0.12s ease;
}
.switch-panels .switcher-header .switcher-add-button:hover:not(.disabled) {
  background: rgba(35, 47, 58, 0.12);
  border-color: rgba(35, 47, 58, 0.2);
}
.switch-panels .switcher-header .switcher-add-button svg {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: block;
}
.switch-panels .switcher-items {
  flex: 1 1 0;
  min-height: 0;
  margin-top: 2px;
}
.switch-panels .switcher-items .switcher-items-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(2, minmax(0, 1fr));
  height: 100%;
  gap: 5px;
}
.switch-panels .disabled {
  opacity: 0.2;
}
.debug-window {
  position: absolute;
  -webkit-user-select: none;
  user-select: none;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: white;
  border: 1px solid black;
  border-radius: 5px;
  width: max-content;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  padding: 10px;
}
.debug-window:has(.debug-window-header:hover) {
  border: 2px dashed #8d8f93;
}
.debug-window .debug-window-header {
  display: flex;
  cursor: move;
  pointer-events: auto;
  padding: 5px;
  justify-content: space-between;
  align-items: center;
}
.debug-window .debug-window-header h1 {
  text-transform: uppercase;
  margin: 0;
  font-size: 16px;
}
.debug-window fieldset {
  border: 1px solid #8d8f93;
  border-radius: 5px;
  padding: 10px;
}
.debug-window fieldset div {
  gap: 5px;
}
/*# sourceMappingURL=broadcast-editor.component.css.map */
